import { isProduction } from '@libs/environment';
import { config } from '../../../config';
import { ProductsPreviewState } from '../nav-state/products-preview.state';
import {
  SolutionsPreviewState,
} from '../nav-state/solutions-preview.state';
import {
  ResourcesPreviewState,
} from '../nav-state/resources-preview.state';
import { BuyPreviewState, IBuyPreviewCards } from '../nav-state/buy-preview.state';
import { cloneDeep } from 'lodash';
import { INavPreviewCards } from '@models/nav.interface';

const year = new Date().getFullYear();
export interface IFooterCol<T> {
  title: string;
  cards: T[];
}

export type FooterState = {
  brand: string;
  logo: string;
  rights: string;
  footerRightsText: string;
  year: number;
  social: FooterSocial;
  firstRow: IBuyPreviewCards[];
  secondRow: [
    IFooterCol<INavPreviewCards>,
    IFooterCol<INavPreviewCards>,
    IFooterCol<INavPreviewCards>,
    IFooterCol<ICompanyFooterCard>,
  ];
  contacts: IFooterContacts;
};

type FooterSocial = Array<{
  name: string;
  link: string;
  icon: string;
}>;

interface IFooterContacts {
  title: string;
  address: {
    ukraine: string;
    slovakia: string;
  };
  titleOficce: string;
  number: {
    usa: string;
    slovakia: string;
  };
  email: string;
}

interface IProductsFooterCol {
  title: string;
  cards: INavPreviewCards[];
}

interface ISolutionsFooterCol {
  title: string;
  cards: INavPreviewCards[];
}

interface IResourcesFooterCol {
  title: string;
  cards: INavPreviewCards[];
}

interface ICompanyFooterCol {
  title: string;
  cards: ICompanyFooterCard[];
}

interface ICompanyFooterCard {
  title: string;
  href: string;
  newTab?: boolean;
}

const copyBuyPreviewState = cloneDeep(BuyPreviewState);
const buyCards = copyBuyPreviewState.cards.sort((a, b) => a.footerOrder - b.footerOrder);
const productCards = ProductsPreviewState.columns.flatMap((column) => column.cards);
const solutionCards = SolutionsPreviewState.columns.flatMap((column) => column.cards);
const resourcesCards = ResourcesPreviewState.columns.flatMap((column) => column.cards);

const productsCol: IProductsFooterCol = { title: 'Products.Nav.Title', cards: productCards };
const solutionCol: ISolutionsFooterCol = { title: 'Solutions.Nav.Title', cards: solutionCards };
const resourcesCol: IResourcesFooterCol = { title: 'Resources.Nav.Title', cards: resourcesCards };
const companyCol: ICompanyFooterCol = {
  title: 'Company.Nav.Title',
  cards: [
    { title: 'AboutUs.Nav.Title', href: '/about-us' },
    { title: 'Careers.Nav.Title', href: '/careers' },
    // TODO: temporary hidden
    // { title: 'Team.Nav.Title', href: '/' },
    // { title: 'PressKit.Nav.Title', href: '/' },
    { title: 'ContactUs.Nav.Title', href: '/contact-us' },
  ],
};

export const FooterState: FooterState = {
  brand: 'GoFinans, Inc',
  logo: '/assets/header/logo/gofinans-logo.svg',
  rights: 'All Rights Reserved',
  footerRightsText: 'Footer.Rights.Full_text',
  year,
  firstRow: buyCards,
  secondRow: [productsCol, solutionCol, resourcesCol, companyCol],
  social: [
    {
      name: 'X',
      link: '/',
      icon: '/social-icons/x.svg',
    },
    {
      name: 'Facebook',
      link: '/',
      icon: '/social-icons/facebook.svg',
    },
  ],
  contacts: {
    title: 'ContactUs.Nav.Title',
    number: {
      usa: '+1 617 778 2988',
      slovakia: '+421 233 070 885',
    },
    email: 'sales@gofinans.com',
    titleOficce: 'Offices.Nav.Title',
    address: {
      slovakia: `Michalska str, 9, Bratislava, 811 03, Slovakia`,
      ukraine: `V.Monomakh str, 17a, Dnipro, 49000, Ukraine`,
    },
  },
};

export interface IFooterStructureData {
  '@context': 'https://schema.org';
  '@type': 'Organization';
  url: string;
  name: string;
  logo: string;
  email: string;
}

export const footerStructureData: IFooterStructureData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  url: config.HOST,
  name: 'GoFinans',
  logo: 'https://gofinans.com/_next/image?url=/assets/header/logo/gofinans-logo.svg&w=96&q=75',
  email: 'sales@gofinans.com',
};
